import { getClientFullPath, getNotifyFullPath, getOrderFullPath, getQueueFullPath } from '../helpers'
import { FIREBASE_ORDER_PLATFORM_TYPE } from '../helpers/enum'
import firebase from '../plugins/firebase'

export default {
  async createQueue (shopId, branchId, psId, queueNumber, tableNumber) {
    const path = getQueueFullPath(shopId, branchId, psId, queueNumber)
    const ref = firebase.database().ref(path)
    return ref.set({
      queue_number: queueNumber.toString(),
      table_number: tableNumber == null ? null : tableNumber.toString(),
      platform: FIREBASE_ORDER_PLATFORM_TYPE.POS, // menu_online | pos
    })
  },

  async updateNotify (shopId, branchId, psId, queueNumber, notifyId, payload) {
    const path = getNotifyFullPath(shopId, branchId, psId, queueNumber, notifyId)
    const ref = firebase.database().ref(path)
    return ref.update(payload)
  },

  async updateNotifies (shopId, branchId, psId, notifies, payload) {
    const updates = notifies.reduce((acc, cur) => {
      const notify = cur
      const path = getNotifyFullPath(shopId, branchId, psId, notify.queue_number, notify.notify_id)
      Object.keys(payload).forEach((key) => {
        acc[`${path}/${key}`] = payload[key]
      })
      return acc
    }, {})
    return firebase.database().ref().update(updates)
  },

  async updateClient (shopId, branchId, psId, clientId, payload) {
    const path = getClientFullPath(shopId, branchId, psId, clientId)
    const ref = firebase.database().ref(path)
    return ref.update(payload)
  },

  async createOrder (shopId, branchId, psId, queueNumber, orderId, payload) {
    const path = getOrderFullPath(shopId, branchId, psId, queueNumber, orderId)
    const ref = firebase.database().ref(path)
    return ref.set(payload)
  },

  async updateOrder (shopId, branchId, psId, queueNumber, orderId, payload) {
    const path = getOrderFullPath(shopId, branchId, psId, queueNumber, orderId)
    const ref = firebase.database().ref(path)
    return ref.update(payload)
  },
}



// WEBPACK FOOTER //
// ./src/api/FirebaseService.js